// src/api/email.js

const FIREBASE_FUNCTION_URL =
  "https://us-central1-wwsmbc.cloudfunctions.net/sendFormEmail";

// Generic POST helper
async function postJson(url, body) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }
  return data;
}

/**
 * 1) Get In Touch form submit
 * payload must match your Firebase function keys
 */
export async function submitGetInTouchForm({
  to = "admin@wwsmb.co.uk", // change to your receiver email
  firstName,
  lastName,
  email,
  message,
}) {
  return postJson(FIREBASE_FUNCTION_URL, {
    type: "getInTouchV2",
    to,
    firstName,
    lastName,
    email,
    message,
  });
}

/**
 * 2) Membership Application submit
 */
export async function submitMembershipForm({
  to = "admin@wwsmb.co.uk", // change to your receiver email
  fullName,
  dob,
  address,
  postcode,
  homeTelephone,
  mobile,
  email,
  emergencyName,
  emergencyContact,
  altName,
  altContact,
  medicalHistory,
  selfDisclosureAnswer,
  selfDisclosureDetails,
  referenceName,
  referenceContact,
}) {
  return postJson(FIREBASE_FUNCTION_URL, {
    type: "membership",
    to,
    fullName,
    dob,
    address,
    postcode,
    homeTelephone,
    mobile,
    email,
    emergencyName,
    emergencyContact,
    altName,
    altContact,
    medicalHistory,
    selfDisclosureAnswer,
    selfDisclosureDetails,
    referenceName,
    referenceContact,
  });
}